// Example uses styled-components, but styled-system works with most other css-in-js libraries as well
import styled from 'styled-components';
import { space, width, fontSize, color, display, borders, borderColor } from 'styled-system';

// Add styled-system functions to your component
const Border = styled.div`
  ${space};
  ${width};
  ${fontSize};
  ${color};
  ${display};
  ${borders};
  ${borderColor};
`;

export default Border;
